"use client";

import { cn } from "@/lib/utils";

import type { FacetOption } from "./facet-option-list";

export function FacetOptionRowContent({
  item,
  isActive,
  disabled,
  barWidth,
  formatCount,
}: {
  item: FacetOption;
  isActive: boolean;
  disabled: boolean;
  barWidth: number;
  formatCount: (count: number) => string;
}) {
  const iconColor = isActive
    ? "text-primary"
    : disabled
      ? "text-muted-foreground/35"
      : "text-muted-foreground/75";
  const Icon = item.icon;
  return (
    <>
      {Icon && (
        <Icon
          className={cn(
            "flex size-5 items-center justify-center text-[16px] leading-none",
            iconColor,
          )}
        />
      )}
      <span
        className={cn("min-w-0 truncate text-[13px] font-semibold", isActive && "text-primary")}
      >
        {item.label}
      </span>
      {item.count != null && (
        <span className="shrink-0 text-[12px] font-semibold tabular-nums opacity-65">
          {formatCount(item.count)}
        </span>
      )}
      {item.count != null && item.count > 0 && (
        <span className="absolute inset-x-3 bottom-1 block h-0.5 rounded-full bg-border/60">
          <span
            className={cn(
              "block h-full rounded-full",
              isActive ? "bg-primary/80" : "bg-muted-foreground/35",
            )}
            style={{ width: `${Math.max(8, barWidth)}%` }}
          />
        </span>
      )}
    </>
  );
}
